import { useContext, useEffect, useState } from "react";
import { AppContext } from "../Context/Context";
import { useNavigate, useParams } from "react-router-dom";
import { checkFeatureEnabled } from "../util/helper/helperFunctions";

//wrapper component checks the plant has the feature available

const FeatureChecker = ({ children, feature }) => {
  const { plantConfig } = useContext(AppContext);
  const [isEnabled, setIsEnabled] = useState(false);
  const { plantCode } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (plantConfig) {
      //checking the plant has this feature enabled

      if (plantConfig) {
        const isEnabled = checkFeatureEnabled(plantConfig, feature);
        !isEnabled ? navigate(`/${plantCode}`) : setIsEnabled(true);
      }
    }
  }, [plantCode, plantConfig, feature]);

  return isEnabled && children;
};

export default FeatureChecker;
